import { render, staticRenderFns } from "./AddRoleP2.vue?vue&type=template&id=6228b654&scoped=true&"
import script from "./AddRoleP2.vue?vue&type=script&lang=js&"
export * from "./AddRoleP2.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleP2.vue?vue&type=style&index=0&id=6228b654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228b654",
  null
  
)

export default component.exports